<template>
  <component
    class="slide-up-down"
    :is="tag"
    :class="{active}">
    <div class="slide-up-down__inner">
      <slot></slot>
    </div>
  </component>
</template>

<script>
export default {
  name: 'SlideUpDown',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
}
</script>
